/**
 * Seeded Random Number Generator (LCG - Linear Congruential Generator)
 * Provides deterministic random numbers for reproducible board generation
 */
export class SeededRNG {
  private seed: number;

  constructor(seed: number) {
    this.seed = seed;
  }

  /**
   * Returns a random number between 0 (inclusive) and 1 (exclusive)
   */
  random(): number {
    // LCG parameters from Numerical Recipes
    const a = 1664525;
    const c = 1013904223;
    const m = 2 ** 32;

    this.seed = (a * this.seed + c) % m;
    return this.seed / m;
  }

  /**
   * Returns a random integer between 0 (inclusive) and max (exclusive)
   */
  randomInt(max: number): number {
    return Math.floor(this.random() * max);
  }

  /**
   * Reset the RNG to a specific seed
   */
  setSeed(seed: number): void {
    this.seed = seed;
  }

  /**
   * Get current seed value
   */
  getSeed(): number {
    return this.seed;
  }
}
